import { motion } from "framer-motion"

const logos = [
    "/assets/logos/akrapovic.png",
    "/assets/logos/f1.png",
    "/assets/logos/capristo.png",
    "/assets/logos/cobr.png",
    "/assets/logos/hre.png",
    "/assets/logos/vossen.png",
    "/assets/logos/bbs.png",
]

export default function LogoSlider() {
    return (
        <div className="flex flex-col gap-1 w-full">
            {/* Heading */}
            <motion.h2
                className="md:text-3xl text-2xl font-semibold text-white text-left m-0 mb-2 leading-tight"
                animate={{ opacity: [1, 0.35, 1] }}
                transition={{ duration: 4, ease: "easeInOut", repeat: Infinity }}
            >
                Dealers For :
            </motion.h2>

            {/* Slider Container */}
            <div className="relative w-full overflow-hidden bg-[#050508] py-1">
                {/* Fade Overlays for Smooth Left/Right Edges */}
                <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[#050508] to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#050508] to-transparent z-10 pointer-events-none" />

                <motion.div
                    className="flex w-max items-center"
                    animate={{ x: ["-50%", "0%"] }}
                    transition={{
                        duration: 20, // Adjust speed here (higher = slower)
                        ease: "linear",
                        repeat: Infinity,
                    }}
                >
                    {/* First set of logos */}
                    <div className="flex gap-12 pr-12">
                        {logos.map((logo, index) => (
                            <div
                                key={`set1-${index}`}
                                className="w-28 h-8 flex items-center justify-center shrink-0 px-2"
                            >
                                <img
                                    src={logo}
                                    alt="brand logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        ))}
                    </div>

                    {/* Second set of logos (Required to make the loop seamless) */}
                    <div className="flex gap-12 pr-12">
                        {logos.map((logo, index) => (
                            <div
                                key={`set2-${index}`}
                                className="w-28 h-8 flex items-center justify-center shrink-0 px-2"
                            >
                                <img
                                    src={logo}
                                    alt="brand logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </div>
    )
}